export enum SQSQueueNameEnum {
  OPTOUTS_UPLOAD = 'optouts-upload',
  SCHEDULE_MESSAGES = 'schedule-messages',
  RECIEVE_MOCK_MESSAGES = 'recieve-mock-messages',
  EXPORTS = 'exports',
}